import { CMAP_URLS } from '~/utils/pdfjs_cmap_urls';

// 他社カルテ発行の処方箋など Adobe 標準 CMap 前提の PDF は、CMap を渡さないと文字が描画されない。
// Turbopack が出力する .bcmap はファイル名にハッシュが付くため、ディレクトリ URL に名前を
// 連結する cMapUrl は使えず、名前から URL を引いて自前で取得する。
export class CMapReaderFactory {
  async fetch({ name }: { name: string }) {
    const url = CMAP_URLS[name];
    if (!url) throw new Error(`Unknown CMap: ${name}`);

    const response = await fetch(url);
    if (!response.ok) throw new Error(`Failed to fetch CMap: ${name} (${response.status})`);

    return { cMapData: new Uint8Array(await response.arrayBuffer()), isCompressed: true };
  }
}
